import { store, persistor } from 'store';
import Navigations from 'navigations';
import 'i18n';
import theme from 'styles/theme.json';
import { Provider } from 'react-redux';
import { GlobalStyle } from 'styles/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modals } from 'components';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <GlobalStyle />
          <ThemeProvider theme={theme}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
              <ToastContainer
                position="top-center"
                autoClose={3000}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                limit={2}
                theme="light"
              />
              <Navigations />
              <Modals.Alert />
            </GoogleOAuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
